var Promise = require('es6-promise').Promise;
var WebPurify = require('webpurify');

window.addEventListener('DOMContentLoaded', function(event) {
  var wp = new WebPurify({
    api_key: '224459e19c97662d8ef28727944f23b6',
    customEndpoint: 'labatt-api.webpurify.net'  // Pass in customEndpoint to override default endpoint
    // , endpoint: 'us' //   // Optional, available choices: 'eu', 'ap'. Default: 'us'.
    // , enterprise: true // Optional, set to true if you are using the enterprise API, allows SSL
  });

  var customProductForm = document.getElementById('AddToCartForm'),
      addToCartButton = document.querySelector('[data-submit-form]'),
      errorMessage = document.querySelector('[data-error-message]'),
      productCustomTextLineOne = document.getElementById('CustomTextLineOne'),
      productCustomTextLineTwo = document.getElementById('CustomTextLineTwo'),
      formActionsWrapper = document.getElementById('formActionsWrapper'),
      errorMessageData = errorMessage.getAttribute('data-error-message'),
      // addMessage = document.querySelector('[data-add-message]'),
      // addMessageData = addMessage.getAttribute('data-add-message'),
      profanityPresent = false,
      liveTargetAddToCart = false;

  if (formActionsWrapper.classList.contains('actions--target-add-to-cart')) {
    liveTargetAddToCart = true;
  }

  var getClosest = function (elem, selector) {
  	for ( ; elem && elem !== document; elem = elem.parentNode ) {
  		if ( elem.matches( selector ) ) return elem;
  	}
  	return null;
  };

  var disableAddBlockButton = function(addBlockButton) {
    addBlockButton.setAttribute('disabled', 'disabled');
    addBlockButton.classList.add('visually-hidden');
  };

  var enableAddBlockButton = function(addBlockButton) {
    addBlockButton.classList.remove('visually-hidden');
    addBlockButton.removeAttribute('disabled');
  };

  var disableAddToCartButton = function() {
    addToCartButton.setAttribute('disabled', 'disabled');

    if (liveTargetAddToCart === true) {
      addToCartButton.classList.add('visually-hidden');
    }
  };

  var enableAddToCartButton = function() {
    if (liveTargetAddToCart === true) {
      addToCartButton.classList.remove('visually-hidden');
    }
    addToCartButton.removeAttribute('disabled');
  };

  var checkAddToCart = function(ctx) {
    if (ctx == true) {
      addToCartButton.setAttribute('disabled', 'disabled');
    } else {
      addToCartButton.removeAttribute('disabled');
      errorMessage.textContent = '';
    }
  };

  var profanityExists = function(state) {
    // console.log(state, 'state inside exists');

    if (state.textOneProfanity === true || state.textTwoProfanity === true) {
      productCustomTextLineOne.textContent = '';
      productCustomTextLineTwo.textContent = '';
      state.previewButton.classList.remove('visually-hidden');
      errorMessage.textContent = errorMessageData;

      // only disable/enable add to cart on keyup if on single purchase PIN product
      if (liveTargetAddToCart === true) {
        disableAddToCartButton();
      } else {
        if (state.addBlockButton) {
          disableAddBlockButton(state.addBlockButton);
        }
        disableAddToCartButton();
      }
      return false;
    }
  };

  var profanityDoesNotExist = function(state, target) {
    // console.log(state, 'state inside DNE');
    if (state.textOneProfanity === false && state.textTwoProfanity === false && state.textOneValue.length >= 1) {

      if (target && typeof target !== 'undefined') {
        if (target.hasAttribute('data-remove') || target.hasAttribute('data-generate-product')) {
          productCustomTextLineOne.textContent = '';
          productCustomTextLineTwo.textContent = '';
        } else {
          // console.log('no profanity!');
          setTimeout(function() {
            productCustomTextLineOne.textContent = state.textOneValue;
            productCustomTextLineTwo.textContent = state.textTwoValue;
          }, 500);
        }
      } else {
        // console.log('no profanity!');
        setTimeout(function() {
          productCustomTextLineOne.textContent = state.textOneValue;
          productCustomTextLineTwo.textContent = state.textTwoValue;
        }, 500);
      }

      // only hide the preview button and swap it for the add button if we have an add button
      // (add button does not exist on PIN campaign prize for custom product)
      if (state.addBlockButton) {
        state.previewButton.classList.add('visually-hidden');
      }
      errorMessage.textContent = '';

      // only disable/enable add to cart on keyup if on single purchase PIN product
      if (liveTargetAddToCart === true) {
        enableAddToCartButton();
      } else {
        enableAddToCartButton();
        if (state.addBlockButton) {
          enableAddBlockButton(state.addBlockButton);
        }
      }
    }
  };

  var liveInputCheck = function(container, target) {
    if (container && typeof container !== 'undefined') {
      var textOneInput = container.querySelector('[name="properties[Name, Line One]"]'),
          textOneValue = textOneInput.value,
          textTwoInput = container.querySelector('[name="properties[Name, Line Two]"]'),
          textTwoValue = textTwoInput.value,
          addBlockButton = container.querySelector('[data-add-block]'),
          previewButton = container.querySelector('[data-preview-button]'),
          state = {
            textOneProfanity: true,
            textTwoProfanity: true,
            textOneValue: textOneValue,
            textTwoValue: textTwoValue,
            addBlockButton: addBlockButton,
            previewButton: previewButton
          };

      wp.check(textOneValue)
      .then(profanity => {
        if (profanity) {
          // console.log('A bunch of sailors in ', textOneValue);
          state.textOneProfanity = true;
          profanityExists(state);
        } else {
          // console.log('No bad stuff in ', textOneValue);
          state.textOneProfanity = false;
          profanityDoesNotExist(state, target);
        }
      });

      wp.check(textTwoValue)
      .then(profanity => {
        if (profanity) {
          // console.log('A bunch of sailors in ', textOneValue);
          state.textTwoProfanity = true;
          profanityExists(state);
        } else {
          // console.log('No bad stuff in ', textTwoValue);
          state.textTwoProfanity = false;
          profanityDoesNotExist(state, target);
        }
      });

      if (target && typeof target !== 'undefined') {
        if (target.hasAttribute('data-remove') || target.hasAttribute('data-generate-product')) {
          productCustomTextLineOne.textContent = '';
          productCustomTextLineTwo.textContent = '';
        }
      }
    } else {
      return false;
    }
  };

  var checkInputs = function(profanityPresent, target) {
    // console.log('profanity present at start of checkInputs: ', profanityPresent);
    var textInputsLineOne = document.querySelectorAll('[name="properties[Name, Line One]"]'),
        textInputsLineTwo = document.querySelectorAll('[name="properties[Name, Line Two]"]'),
        allTextInputs = [];

    for (i = 0; i < textInputsLineOne.length; i++) {
      allTextInputs.push(textInputsLineOne[i]);
    }

    for (j = 0; j < textInputsLineTwo.length; j++) {
      allTextInputs.push(textInputsLineTwo[j]);
    }

    for (k = 0; k < allTextInputs.length; k++) {
      var allInputs = allTextInputs[k],
          allText = allTextInputs[k].value;

      if (typeof target !== 'undefined') {
        if (liveTargetAddToCart == true) {
          var container = getClosest(target, '#AddToCartForm');
        } else {
          var container = getClosest(target, '.product-custom__block');
        }
      } else {
        // default to top-level form
        var container = document.querySelector('.product-custom__form');
      }

      if (!container && typeof container !== 'undefined') {
        // default to top-level form
        var container = document.querySelector('.product-custom__form');
      }


      var addBlockButton = container.querySelector('[data-add-block]'),
          previewButton = container.querySelector('[data-preview-button]');

      allInputs.addEventListener('keyup', function() {
        var value = this.value;
        if (liveTargetAddToCart == true) {
          disableAddToCartButton();
        } else {
          if (addBlockButton) {
            disableAddBlockButton(addBlockButton);
          }
          disableAddToCartButton();
        }
        previewButton.classList.remove('visually-hidden');

        // if (value.length < 1) {
        //   previewButton.setAttribute('disabled', 'disabled');
        //   previewButton.classList.add('disabled');
        // } else {
        //   previewButton.removeAttribute('disabled');
        //   previewButton.classList.remove('disabled');
        // }
      });

      liveInputCheck(container, target);
    }
  };

  var initPreviewButtons = function() {
    document.addEventListener('click', function(event) {
      if (event.target.hasAttribute('data-preview-button')) {
        event.preventDefault();
        var target = event.target;
        if (!target.getAttribute('disabled')) {
          // console.log(target, ' clicked');
          checkInputs(profanityPresent, target);
        }
      } else if (event.target.hasAttribute('data-generate-product')) {
        productCustomTextLineOne.textContent = '';
        productCustomTextLineTwo.textContent = '';
      }
    }, false);
  };

  document.addEventListener('click', function(event) {
    var target = event.target;
    if (event.target.hasAttribute('data-check-inputs')) {
      checkInputs(profanityPresent, target);
      initPreviewButtons();
    }
  });

  initPreviewButtons();
});
